module.exports = __webpack_public_path__ + "img/130.5d8e49a5.jpg";